import React from 'react';

export const OnboardingContext = React.createContext({
  currentStep: 0,
  isValid: false,
  isComplete: false,
  forms: [],
  progress: [],
  steps: [],
  resets: [],
  actions: {
    assignTrigger: () => {},
    triggerSubmit: () => {},
    setValidState: () => {},
    isValid: () => {},
    initSteps: this.initSteps,
    markComplete: this.markComplete,
    reset: this.reset,
    resetAll: this.resetAll,
    setStep: this.setStep
  }
});



// WEBPACK FOOTER //
// ./src/components/onboarding/OnboardingContext.js